import { Toaster } from '@/components/ui/sonner';

import './styles/globals.css';

import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { Outlet, Route, Routes } from 'react-router';

import { AdminCallsPage } from '@/app/(app)/admin/calls/page';
import { AdminEmployeesPage } from '@/app/(app)/admin/employees/page';
import { AdminOfficesPage } from '@/app/(app)/admin/offices/page';
import { AdminOrgsPage } from '@/app/(app)/admin/orgs/page';
import { AdminLinksPage } from '@/app/(app)/admin/page';
import { AiCoachPage } from '@/app/(app)/analytics/ai-coach/page';
import { CallAnalyticsPage } from '@/app/(app)/analytics/call-analytics/[id]/page';
import { CallAnalyticsTablePageContent } from '@/app/(app)/analytics/call-analytics/page';
import { MetricsRegistryProvider } from '@/app/(app)/analytics/call-analytics/provider';
import { AppLayout } from '@/app/(app)/app-layout';
import { CallsPage } from '@/app/(app)/calls/page';
import { CustomerPage } from '@/app/(app)/customers/[id]/page';
import CustomersPage from '@/app/(app)/customers/page';
import { HomePage } from '@/app/(app)/page';
import { RoutesPage } from '@/app/(app)/routes/page';
import { EmployeePage } from '@/app/(app)/settings/employees/[id]/page';
import { EmployeesPage } from '@/app/(app)/settings/employees/page';
import { OfficePage } from '@/app/(app)/settings/office/page';
import { SettingsPage } from '@/app/(app)/settings/page';
import { PestsPage } from '@/app/(app)/settings/pests/page';
import { ServicePlanPage } from '@/app/(app)/settings/service_plans/[id]/page';
import { ServicePlansPage } from '@/app/(app)/settings/service_plans/page';
import { ServiceTypePage } from '@/app/(app)/settings/service_types/[id]/page';
import { ServiceTypesPage } from '@/app/(app)/settings/service_types/page';
import { ServiceAreasPage } from '@/app/(app)/settings/service-areas/page';
import { SkillsPage } from '@/app/(app)/settings/skills/page';
import { VoiceAgentPage } from '@/app/(app)/voice-agent/page';
import AuthLayout from '@/app/(auth)/layout';
import { LoginPage } from '@/app/(auth)/login/page';
import { QueryClientProvider } from '@/components/providers/query-client-provider';

export function App() {
  return (
    <QueryClientProvider>
      <NuqsAdapter>
        <AppRoutes />
        <Toaster position='top-right' />
      </NuqsAdapter>
    </QueryClientProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        element={
          <AuthLayout>
            <Outlet />
          </AuthLayout>
        }
      >
        <Route path='/auth/login' element={<LoginPage />} />
      </Route>

      <Route
        element={
          <AppLayout>
            <Outlet />
          </AppLayout>
        }
      >
        <Route path='/' element={<HomePage />} />
        <Route path='calls' element={<CallsPage />} />
        <Route path='customers' element={<CustomersPage />} />
        <Route path='customers/:id' element={<CustomerPage />} />
        <Route path='routes' element={<RoutesPage />} />
        <Route path='settings' element={<SettingsPage />} />
        <Route path='settings/office' element={<OfficePage />} />
        <Route path='settings/employees' element={<EmployeesPage />} />
        <Route path='settings/employees/:id' element={<EmployeePage />} />
        <Route path='settings/skills' element={<SkillsPage />} />
        <Route path='settings/skills/:id' element={<SkillsPage />} />
        <Route path='settings/service-areas' element={<ServiceAreasPage />} />
        <Route path='settings/service-areas/:id' element={<ServiceAreasPage />} />
        <Route path='settings/pests' element={<PestsPage />} />
        <Route path='settings/pests/:id' element={<PestsPage />} />
        <Route path='settings/service_types' element={<ServiceTypesPage />} />
        <Route path='settings/service_types/:id' element={<ServiceTypePage />} />
        <Route path='settings/service_plans' element={<ServicePlansPage />} />
        <Route path='settings/service_plans/:id' element={<ServicePlanPage />} />
        <Route path='voice-agent' element={<VoiceAgentPage />} />

        <Route path='analytics'>
          <Route path='ai-coach' element={<AiCoachPage />} />
          <Route
            element={
              <MetricsRegistryProvider>
                <Outlet />
              </MetricsRegistryProvider>
            }
          >
            <Route path='call-analytics' element={<CallAnalyticsTablePageContent />} />
            <Route path='call-analytics/:id' element={<CallAnalyticsPage />} />
          </Route>
        </Route>

        <Route path='admin' element={<AdminLinksPage />} />
        <Route path='admin/orgs' element={<AdminOrgsPage />} />
        <Route path='admin/offices' element={<AdminOfficesPage />} />
        <Route path='admin/employees' element={<AdminEmployeesPage />} />
        <Route path='admin/calls' element={<AdminCallsPage />} />
      </Route>
    </Routes>
  );
}
